import * as React from 'react';

export const AiRestrictionContext = React.createContext<string | null>(null);

interface AiRestrictionContextProviderProps {
  children: React.ReactNode;
  aiRestrictedGroup: string | null;
}

export const AiRestrictionContextProvider: React.FC<AiRestrictionContextProviderProps> = ({ children, aiRestrictedGroup }) => (
  <AiRestrictionContext.Provider value={aiRestrictedGroup}>
    {children}
  </AiRestrictionContext.Provider>
);

export default AiRestrictionContextProvider;
